import '../../../../filters';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'OmInvestigation',
  components: {
    datetime: Datetime,
    DateTime,
    DetailsComp: require('./details.vue').default,
    ManpowersComp: require('./manpowers.vue').default,
    SupportsComp: require('./supports.vue').default,
    AttachmentsComp: require('./attachments.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      currentPage: 'details',
      message: '',
    }
  },
  computed: {
    outcomeId: function () {
      return this.dataObj.appData.outcomeId;
    },
  },
  watch: {
    outcomeId: function (value) {
      this.dataObj.appData.outcomeId = parseInt(value);
    },
  },
  created() {
    //console.log("sup serv", this.$store.state.isFieldWorker);
    console.log("data investigation", this.dataObj.appData);
   /* this.showRates();*/
  },
  methods: {
    //showRates: function () {
    //  if (this.$store.state.isFieldWorker)
    //    this.dataObj.appData.settings.showSupportServicesRates = false;

    //  if (this.$store.state.isFieldWorker)
    //    this.dataObj.appData.settings.showManpowerRates = false;

    //},
    gotManPowerVisible(value) {
      return value? this.currentPage === 'manpowers' &&
        ((this.outcomeId && this.outcomeId === 1 && this.dataObj.appData.settings.allowMpAssignment) ||
          (this.outcomeId && this.outcomeId === 2 && this.dataObj.appData.settings.allowMp6Assignment)) : 
        this.currentPage !== 'manpowers' &&
        ((this.outcomeId && this.outcomeId === 1 && this.dataObj.appData.settings.allowMpAssignment) ||
          (this.outcomeId && this.outcomeId === 2 && this.dataObj.appData.settings.allowMp6Assignment));
    },
    gotSupportVisible(value) {
      return value ? this.currentPage === 'supports' &&
        ((this.outcomeId && this.outcomeId === 1 && this.dataObj.appData.settings.allowSsAssignment) ||
          (this.outcomeId && this.outcomeId === 2 && this.dataObj.appData.settings.allowSs6Assignment)) :
        this.currentPage !== 'supports' &&
        ((this.outcomeId && this.outcomeId === 1 && this.dataObj.appData.settings.allowSsAssignment) ||
          (this.outcomeId && this.outcomeId === 2 && this.dataObj.appData.settings.allowSs6Assignment));
    },
    gotoPage(page) {
      this.currentPage = page;
      switch (page) {
        case "details":
          break;
        case "manpowers":
          break;
        case "supports":
          break;
        case "attachments":
          break;
        default:
        // do nothing
      }
    },
  },
  
}

